module.exports = __webpack_public_path__ + "img/2.1a88a9a5.png";